// Slider.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import Blog from '../menhome/Blog'
// removed: import Bgone from '../../assets/image/bg/slider-bg-1.png';
import Bgtwo from '../../assets/image/bg/slider-two-bg-1.png';
import OwlCarousel from 'react-owl-carousel';
import './SliderFixes.css';

function Slider() {
  const settings = {
    loop: false,
    autoplay: false,
    nav: false,
    items: 1,
    dots: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    smartSpeed: 0,
    autoplayHoverPause: false,
    animateIn: '',
    animateOut: '',
  };

  return (
    <>
      <section className="main-slider">
        <OwlCarousel
          className="main-slider-swiper owl-carousel owl-theme"
          {...settings}
        >
          {/* single static slide */}
          <div className="item">
            <div
              className="item-slider-bg"
              style={{ backgroundImage: `url(${Bgtwo})` }}
            />
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="slider-content">
                    <div className="slider-tagline">
                      Access Your Government Anytime, Anywhere.
                    </div>
                    <h1 className="section-title">
                      Empowering Citizens with On-Demand State Services
                    </h1>
                    <Link to="/contact" className="btn btn-primary">
                      Discover More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </OwlCarousel>
      </section>

      {/* departments unchanged, with icons */}
      <section className="department-section">
        <div className="container">
          <div className="department-section-inner">
            <div className="row row-gutter-y-40">
              {/* Departments in required order */}
              <div className="col-xl-2 col-lg-4 col-md-6">
                <div className="department-card">
                  <div className="department-card-icon">
                    <Link to="/department/dmv">
                      <i className="fa-solid fa-car" />
                    </Link>
                  </div>
                  <div className="department-card-content">
                    <h5>
                      <Link to="/department/dmv">Motor Vehicles</Link>
                    </h5>
                  </div>
                </div>
              </div>

              <div className="col-xl-2 col-lg-4 col-md-6">
                <div className="department-card">
                  <div className="department-card-icon">
                    <Link to="/department/health">
                      <i className="fa-solid fa-heart" />
                    </Link>
                  </div>
                  <div className="department-card-content">
                    <h5>
                      <Link to="/department/health">Health Services</Link>
                    </h5>
                  </div>
                </div>
              </div>

              <div className="col-xl-2 col-lg-4 col-md-6">
                <div className="department-card">
                  <div className="department-card-icon">
                    <Link to="/department/education">
                      <i className="fa-solid fa-book" />
                    </Link>
                  </div>
                  <div className="department-card-content">
                    <h5>
                      <Link to="/department/education">Education</Link>
                    </h5>
                  </div>
                </div>
              </div>

              <div className="col-xl-2 col-lg-4 col-md-6">
                <div className="department-card">
                  <div className="department-card-icon">
                    <Link to="/department/employment">
                      <i className="fa-solid fa-briefcase" />
                    </Link>
                  </div>
                  <div className="department-card-content">
                    <h5>
                      <Link to="/department/employment">Employment Services</Link>
                    </h5>
                  </div>
                </div>
              </div>

              <div className="col-xl-2 col-lg-4 col-md-6">
                <div className="department-card">
                  <div className="department-card-icon">
                    <Link to="/department/housing">
                      <i className="fa-solid fa-house" />
                    </Link>
                  </div>
                  <div className="department-card-content">
                    <h5>
                      <Link to="/department/housing">Housing</Link>
                    </h5>
                  </div>
                </div>
              </div>

              <div className="col-xl-2 col-lg-4 col-md-6">
                <div className="department-card">
                  <div className="department-card-icon">
                    <Link to="/department/family-services">
                      <i className="fa-solid fa-users" />
                    </Link>
                  </div>
                  <div className="department-card-content">
                    <h5>
                      <Link to="/department/family-services">Family Services</Link>
                    </h5>
                  </div>
                </div>
              </div>

              <div className="col-xl-2 col-lg-4 col-md-6">
                <div className="department-card">
                  <div className="department-card-icon">
                    <Link to="/department/public-safety">
                      <i className="fa-solid fa-shield" />
                    </Link>
                  </div>
                  <div className="department-card-content">
                    <h5>
                      <Link to="/department/public-safety">Public Safety</Link>
                    </h5>
                  </div>
                </div>
              </div>

              <div className="col-xl-2 col-lg-4 col-md-6">
                <div className="department-card">
                  <div className="department-card-icon">
                    <Link to="/department/senior-services">
                      <i className="fa-solid fa-wheelchair" />
                    </Link>
                  </div>
                  <div className="department-card-content">
                    <h5>
                      <Link to="/department/senior-services">Senior Services</Link>
                    </h5>
                  </div>
                </div>
              </div>

              <div className="col-xl-2 col-lg-4 col-md-6">
                <div className="department-card">
                  <div className="department-card-icon">
                    <Link to="/department/veterans">
                      <i className="fa-solid fa-flag-usa" />
                    </Link>
                  </div>
                  <div className="department-card-content">
                    <h5>
                      <Link to="/department/veterans">Veterans Affairs</Link>
                    </h5>
                  </div>
                </div>
              </div>

              <div className="col-xl-2 col-lg-4 col-md-6">
                <div className="department-card">
                  <div className="department-card-icon">
                    <Link to="/department/emergency">
                      <i className="fa-solid fa-fire-extinguisher" />
                    </Link>
                  </div>
                  <div className="department-card-content">
                    <h5>
                      <Link to="/department/emergency">Emergency Management</Link>
                    </h5>
                  </div>
                </div>
              </div>

              <div className="col-xl-2 col-lg-4 col-md-6">
                <div className="department-card">
                  <div className="department-card-icon">
                    <Link to="/department/technology">
                      <i className="fa-solid fa-microchip" />
                    </Link>
                  </div>
                  <div className="department-card-content">
                    <h5>
                      <Link to="/department/technology">
                        Innovation<br />Technology
                      </Link>
                    </h5>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* <div className="department-search-section">
          <div className="container">
            <form className="department-search-form">
              <input
                type="text"
                placeholder="Search for departments or services"
                name="search"
              />
              <button type="submit">View All Departments</button>
            </form>
          </div>
        </div> */}
        <Blog/>
      </section>
    </>
  );
}

export default Slider;
